import { render, staticRenderFns } from "./group-title.vue?vue&type=template&id=442c11b4&scoped=true"
import script from "./group-title.vue?vue&type=script&lang=js"
export * from "./group-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c11b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442c11b4')) {
      api.createRecord('442c11b4', component.options)
    } else {
      api.reload('442c11b4', component.options)
    }
    module.hot.accept("./group-title.vue?vue&type=template&id=442c11b4&scoped=true", function () {
      api.rerender('442c11b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/draw-menu/components/group-title.vue"
export default component.exports